import React from "react";
//Media queries Breakpoints.
export const breakpoints = {
  xs: "@media only screen and (max-width: 575px)",
  sm: "@media only screen and (min-width: 576px)",
  md: "@media only screen and (min-width: 768px)",
  lg: "@media only screen and (min-width: 992px)",
  xl: "@media only screen and (min-width: 1200px)",
  xxl: "@media only screen and (min-width: 1600px)",
};

export const color = {
  white: "#FFFFFF",
  black: "#000000",
  primary10: "#F36222",
  primary11: "#F5841F",
  primary12: "#FCB43C",
  primary20: "#004778",
  primary21: "#0284C9",
  primary22: "#00B8F0",
  primary30: "#00833D",
  primary31: "#50B948",
  primary32: "#C4D82D",
  primaryGradient10: "linear-gradient(#f58415, #f36222)",
  primaryGradient20: "linear-gradient(#0284C9, #004778)",
  primaryGradient30: "linear-gradient(#50B948, #00833D)",
  secondary10: "#FCD6B1",
  secondary11: "#FDE6D2",
  secondary12: "#FEF2E8",
  secondary20: "#B0D7EC",
  secondary21: "#C9E3F1",
  secondary22: "#E2EFF6",
  secondary30: "#C7E7C5",
  secondary31: "#D9EED7",
  secondary32: "#EAF4E9",
  tertiary10: "#57585A",
  tertiary11: "#DCDDDF",
  tertiary20: "#E6E7E9",
  tertiary21: "#F2F2F2",
  tertiary30: "#FD4532",
  tertiary31: "#FE7264",
  tertiary32: "#FCD7D7",
};

export const themeCommon = (themeOverride = {}) => ({
  ...breakpoints,
  ...color,
  ...themeOverride,
});
